import { render } from "./campaigns.vue?vue&type=template&id=aefd0eea&scoped=true"
import script from "./campaigns.vue?vue&type=script&lang=js"
export * from "./campaigns.vue?vue&type=script&lang=js"

import "./campaigns.vue?vue&type=style&index=0&id=aefd0eea&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aefd0eea"]])

export default __exports__